import React from 'react';
import UpperPart from './UpperPart';
import Newsletter from "./Newsletter";
import Footer from "./Footer";

const Landing = () => (
    <div className="landing">
        <UpperPart />
        <Newsletter />
        <Footer />
    </div>
);

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing.js